import * as React from "react";

interface DartIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  size?: number | string;
}

export const DartIcon = React.forwardRef<SVGSVGElement, DartIconProps>(
  ({ className, size = 38, width, height, ...props }, ref) => (
    <svg
      ref={ref}
      width={width || size}
      height={height || size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Main circle/target - white fill with purple outline */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9331 14.5519C25.6559 14.8294 25.3238 15.0395 24.9624 15.1717C24.9873 15.4445 25 15.7207 25 16C25 20.9706 20.9706 25 16 25C11.0294 25 7 20.9706 7 16C7 11.0294 11.0294 7 16 7C16.2792 7 16.5554 7.01271 16.8281 7.03759C16.9599 6.67681 17.1695 6.34528 17.4461 6.06831L20.702 2.80917C19.2324 2.28527 17.6495 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30C23.732 30 30 23.732 30 16C30 14.3485 29.7141 12.7638 29.189 11.2928L25.9331 14.5519Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="1"
      />
      
      {/* Inner circle - white fill with purple outline */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6662 10.62L16.6661 9.03128C16.4469 9.01058 16.2247 9 16 9C12.134 9 9 12.134 9 16C9 19.866 12.134 23 16 23C19.866 23 23 19.866 23 16C23 15.7753 22.9894 15.5531 22.9687 15.3338L21.3806 15.3337L18.3572 18.3575C17.0556 19.6594 14.945 19.6595 13.6432 18.3579C12.3413 17.0562 12.3412 14.9457 13.6428 13.6439L16.6662 10.62Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="1"
      />
      
      {/* Arrow - purple fill */}
      <path
        d="M20.5528 13.333L24.0462 13.3333C24.223 13.3333 24.3926 13.2631 24.5176 13.1381L29.7762 7.88C30.192 7.46432 29.9053 6.75315 29.3175 6.74203L25.3327 6.66663L25.2573 2.68168C25.2462 2.09392 24.5351 1.8072 24.1194 2.22288L18.8608 7.48117C18.7358 7.60621 18.6655 7.77581 18.6655 7.95264L18.6658 11.4488L15.0571 15.058C14.5365 15.5787 14.5365 16.4229 15.0573 16.9436C15.578 17.4642 16.4222 17.4642 16.9429 16.9434L20.5528 13.333Z"
        fill="currentColor"
      />
    </svg>
  )
);

DartIcon.displayName = "DartIcon";
